import React from 'react'
import SchemaTag from '../SchemaTag.jsx'
import { object, string, array, bool } from 'prop-types'

class TerminalStatsRichSnippets extends React.Component {
  getReviewsMetaDataFromFeed () {
    const { location, pageData, functionParams = [], terminal } = this.props
    try {
      const newTerminal = (functionParams[0] !== undefined && functionParams[0].length > 0) ? functionParams[0] : terminal
      const feedData = this.getFeedPath()
      const locationData = require('../../../../../config/exports/buildTimeOnly/reviews/' + feedData.path + location.code + (newTerminal.length > 0 ? '_' + newTerminal : '') + '.json')
      return { meta: locationData.meta, type: feedData.type, productName: pageData.pageTitle.split(' | ')[0] }
    } catch (e) {
      return false
    }
  }

  // http://stackoverflow.com/a/2901298/1134191
  numberWithCommas (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return {
          path: 'parking/meta/',
          type: 1
        }
      case 'HCP':
        return {
          path: 'hotels/meta/',
          type: 2
        }
      case 'HO':
        return {
          path: 'hotels/meta/',
          type: 2
        }
    }

    return { }
  }

  render () {
    const { id, noSchemaMarkup, functionParams = [] } = this.props
    const data = this.getReviewsMetaDataFromFeed()
    return (
      <SchemaTag tagType='p' noSchemaMarkup={noSchemaMarkup} id={id} className='leftList' itemScope itemType='http://schema.org/Product'>
        { data && data.meta && data.type && data.productName && (
          <span>
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='name'>{ data.productName }</SchemaTag>{ ' is rated, on average ' }
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='aggregateRating' itemScope itemType='http://schema.org/AggregateRating'>
              <SchemaTag tagType='meta' noSchemaMarkup={noSchemaMarkup} itemProp='bestRating' content='100' />
              <SchemaTag tagType='meta' noSchemaMarkup={noSchemaMarkup} itemProp='worstRating' content='1' />
              <span className='priceSmall'>
                <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingValue'>{ data.meta.averageAsPercentage }</SchemaTag>
              </span>
              {' out of '}<span className='priceSmall'>100</span>{ ' by ' }
              <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingCount'>{ this.numberWithCommas(data.meta.reviewed) }</SchemaTag>{ ' customers.' }
            </SchemaTag>
          </span>
        ) }
        { functionParams[1] !== undefined && functionParams[1].length > 0 && (
          <span className='readReviews'>{ ' ' }<a href={functionParams[1]}>Read reviews</a></span>
        )}
      </SchemaTag>
    )
  }
}

TerminalStatsRichSnippets.propTypes = {
  id: string.isRequired,
  terminal: string,
  location: object,
  pageData: object,
  functionParams: array,
  noSchemaMarkup: bool
}

TerminalStatsRichSnippets.defaultProps = {
  noSchemaMarkup: false
}

export default TerminalStatsRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/terminal-stats-richsnips.jsx